export default {
  title: "",
  subtitle: "Information on the Bank Accounts (List, Get and Update)",
  path: "bank_accounts_generals",
  paragraph: "You can check all bank accounts related to a customer using the following endpoint to list it, you’ll use the {id} of the customer:",
  request: {
    method: "GET",
    endpoint: "/subject/:id/bank_accounts",
    responses: {
      "data": [
        {
          "routing_number": null,
          "owner_name": "Mauricio Silva",
          "owner_document_number": "24189952087",
          "owner_company": {
            "social_name": "Mauricio Silva",
            "id": "0be2c99a-bb6e-4a1f-97a5-5eeaff0671c8",
            "document_type": "cpf",
            "document_number": "24189952087"
          },
          "intermediary_bank_account_id": null,
          "id": "3e217a9d-bfc7-48bc-b436-304f3edbd82f",
          "iban": null,
          "currency": "BRL",
          "branch_number": "134",
          "branch_country": "BRA",
          "pix_info": null,
          "nickname": null,
          "bank": {
            "swift": "BBDEBRSP",
            "country": "BRA",
            "ispb": null,
            "name": "Banco Bradesco S.A.",
            "id": "618804fc-bc62-4754-bf24-651df9a098b3",
            "code": "237"
          },
          "account_type": "conta-corrente",
          "account_number": "1350056",
          "aba": null
        }
      ]
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Customer UUID"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/CustomerBankAccountsGenerals.js